import React from 'react';
import {makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import {AvailStringField} from '../../../../value-comparing/helper-components';
import MetadataSection from './metadata-section';
import {ValueComparer} from '../../../../value-comparing/value-comparer';

const useStyles = makeStyles(theme => ({
  assetContainer: {
    paddingLeft: theme.spacing(2),
  },
  assetsSectionWrapper: {
    borderLeft: '1px solid black',
  },
}));

const AssetAvailSection = ({assetsList, oldValue}) => {
  const classes = useStyles();

  const valueComparer = new ValueComparer();

  const renderRequiredComponent = (valueToRender, oldValueToCompare, currentKey) => {
    if (valueComparer.isValue(valueToRender)) {
      return (
        <AvailStringField
          assignedKey={currentKey}
          key={currentKey}
          oldValue={oldValueToCompare}
          value={valueToRender}
        />
      );
    }

    if (currentKey.toLowerCase() === 'metadata') {
      return <MetadataSection key={currentKey} metadataValues={valueToRender} oldValue={oldValueToCompare} />;
    }
  };

  return (
    <div className={classes.assetsSectionWrapper}>
      <h3>Asset{assetsList.length > 1 ? 's' : ''}</h3>
      <div className={classes.assetContainer}>
        {assetsList.map((assetSectionValues, index) => {
          const oldAssetVersion = oldValue && oldValue[index];

          return Object.keys(assetSectionValues).map(key =>
            renderRequiredComponent(assetSectionValues[key], oldAssetVersion?.[key], key)
          );
        })}
      </div>
    </div>
  );
};

AssetAvailSection.propTypes = {
  assetsList: PropTypes.array,
  oldValue: PropTypes.array,
};
export default AssetAvailSection;
